export default __webpack_public_path__ + "static/logo_mdec-3d977a887cac60525bcdc6a0ea614dcf.png";